import React from "react";
import InstitutionSolutionsPage from "@components/Pages/InstitutionSolutionsPage/InstitutionSolutionsPage";

export default function Software() {
    return <InstitutionSolutionsPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../../locales/${locale}.json`)).default,
        },
    };
}
